import React, {Component} from 'react';
import './home.scss';
import home_contact_phone from './../../assets/home_contact_phone.png';
import home_contact_message from './../../assets/home_contact_phone.png';
import bg from './../../assets/bg.png';


class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {
        const {} = this.state;

        return (
            <div className="home-page">
                <div className="app-head">
                    <div className="left">
                        基底生物科技(巴中)有限责任公司
                    </div>
                    <div className="right">
                        <div className="item">经典案例</div>
                        <div className="item">团队介绍</div>
                        <div className="item">联系我们</div>
                    </div>
                </div>

                <img className="bg" src={bg} alt=""/>


                <div className="app-footer white">
                    {/*<h2>联系我们</h2>*/}

                    {/*<p className="c-name">公司名称：成都视为科技有限公司</p>*/}

                    <div className="f-center">
                        <div className="f-block">
                            {/*<div className="item-icon" style={{backgroundImage: 'url(' + home_contact_phone + ')'}}/>*/}
                            <div className="item-content">
                                {/*<div><span>电话</span><a href="tel:028-83165979">：028-86023235</a></div>*/}
                                <div><span>电话</span><a href="tel:028-83165979">：028-62083507</a></div>
                            </div>
                        </div>
                        <div className="f-block">
                            {/*<div className="item-icon" style={{backgroundImage: 'url(' + home_contact_message + ')'}}/>*/}
                            <div className="item-content">
                                {/*<div><span>邮箱</span><a href="mailTo:dezehudong@163.com">：chengjinfeng@jidihudong.com</a>*/}
                                <div><span>邮箱</span><a href="mailTo:dezehudong@163.com">：chengmin@jidisw.com</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*<p className="c-copyright">COPYRIGHT BY CHENGDUDEZE</p>*/}
                    {/*<p className="serial-num">蜀ICP备2021003487号-1*/}
                    <p className="serial-num">
                        {/*&nbsp;&nbsp;&nbsp;&nbsp;*/}
                        {/*<a target="_black"*/}
                        {/*   href="https://beian.miit.gov.cn">蜀ICP备2022015897号-1</a>*/}
                        <a href="https://beian.miit.gov.cn" className="icpInfo" target="_blank"
                           // rel="noreferrer">蜀ICP备19023232号-4</a>
                           rel="noreferrer">蜀ICP备2025140225号-1</a>
                        {/*<a target="_black" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502030226">京公网安备11010502030226</a>*/}
                    </p>
                </div>
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home/home.js
